/* import { FlyingSVG } from "./FlyingSVG"; */
import anime from "https://cdn.jsdelivr.net/npm/animejs@3.2.2/lib/anime.es.js";
const DEFAULT_MAIN_TEXT =
  "Chcete udělat radost našim GIS specialistům a povolit cookies jen pro měření návštěvnosti a používání této aplikace?";
const DEFAULT_TITLE = "Cookies";
const DEFAULT_ACCEPT_BT_TEXT = "Nemám s tím problém";
const DEFAULT_REJECT_BT_TEXT = "Bohužel ne";
const GA_ID = "G-MHDJ5LG7QW";
const DEFAULT_COLORS = [
  "#212529",
  "#343a40",
  "#495057",
  "#6c757d",
  "#adb5bd",
  "#ced4da",
];

// SVG - Path
const DEFAULT_HEART_PATH =
  "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z";

const COKIES_SVG_PATH =
  "m10,20.03c-1.38,0-2.68-.26-3.9-.79s-2.28-1.24-3.18-2.14-1.61-1.96-2.14-3.18-.79-2.52-.79-3.9c0-1.25.24-2.48.73-3.68.48-1.2,1.16-2.27,2.03-3.21s1.91-1.7,3.13-2.28,2.55-.86,4-.86c.35,0,.71.02,1.08.05.37.03.74.09,1.13.18-.15.75-.1,1.46.15,2.13s.63,1.22,1.13,1.66,1.1.75,1.79.91,1.4.13,2.14-.13c-.43.98-.37,1.93.19,2.83s1.39,1.37,2.49,1.4c.02.18.03.35.04.51s.01.33.01.51c0,1.37-.26,2.65-.79,3.86s-1.24,2.27-2.14,3.18-1.96,1.63-3.18,2.15-2.52.79-3.9.79Zm-1.5-12c.42,0,.77-.15,1.06-.44s.44-.65.44-1.06-.15-.77-.44-1.06-.65-.44-1.06-.44-.77.15-1.06.44-.44.65-.44,1.06.15.77.44,1.06.65.44,1.06.44Zm-2,5c.42,0,.77-.15,1.06-.44s.44-.65.44-1.06-.15-.77-.44-1.06-.65-.44-1.06-.44-.77.15-1.06.44-.44.65-.44,1.06.15.77.44,1.06.65.44,1.06.44Zm6.5,1c.28,0,.52-.1.71-.29s.29-.43.29-.71-.1-.52-.29-.71-.43-.29-.71-.29-.52.1-.71.29-.29.43-.29.71.1.52.29.71.43.29.71.29Zm-3,4c2.03,0,3.84-.7,5.41-2.1s2.44-3.18,2.59-5.35c-.83-.37-1.49-.87-1.96-1.5-.48-.63-.8-1.34-.96-2.13-1.28-.18-2.38-.73-3.3-1.65s-1.48-2.02-1.7-3.3c-1.33-.03-2.5.21-3.51.73s-1.85,1.18-2.53,1.99-1.18,1.69-1.53,2.64-.51,1.84-.51,2.68c0,2.22.78,4.1,2.34,5.66,1.56,1.56,3.45,2.34,5.66,2.34Z";
const Thumps_DOWN =
  "M13.4876 0.15999999999999998H3.5072666666666668c-0.5502 0.00019999999999999998 -1.0829333333333333 0.19326666666666664 -1.5054666666666665 0.5456666666666666 -0.4226 0.3523333333333333 -0.7082666666666666 0.8417333333333332 -0.8072666666666667 1.3829333333333331l-0.9957333333333334 5.4879999999999995c-0.062 0.33899999999999997 -0.048799999999999996 0.6876 0.0388 1.0209333333333332 0.08753333333333332 0.3333333333333333 0.24733333333333332 0.6433333333333333 0.4679333333333333 0.9082 0.22066666666666668 0.2647333333333333 0.49679999999999996 0.47773333333333334 0.8088666666666666 0.6240666666666667 0.3121333333333333 0.1462 0.6525333333333333 0.22206666666666666 0.9972 0.22219999999999998H6.086666666666667l-0.4390666666666666 1.1210666666666667c-0.18259999999999998 0.4908666666666666 -0.24339999999999998 1.0187333333333333 -0.17719999999999997 1.5383333333333333 0.0662 0.5195333333333333 0.25739999999999996 1.0152666666666665 0.5573333333333332 1.4446666666666665 0.2998666666666666 0.4294 0.6994666666666666 0.7796 1.1644666666666665 1.0206666666666666 0.46486666666666665 0.241 0.9814666666666666 0.36566666666666664 1.5051999999999999 0.36319999999999997 0.1508 -0.0002666666666666667 0.2982666666666667 -0.04413333333333333 0.42479999999999996 -0.12613333333333332 0.12653333333333333 -0.08206666666666666 0.22673333333333334 -0.19886666666666666 0.28859999999999997 -0.33640000000000003l2.2344 -5.025399999999999h1.8423999999999998c0.6237333333333333 0 1.222 -0.24786666666666668 1.6630666666666667 -0.6889333333333334 0.44113333333333327 -0.4410666666666666 0.6889333333333334 -1.0393333333333332 0.6889333333333334 -1.6630666666666667V2.5119999999999996c0 -0.6237999999999999 -0.24779999999999996 -1.222 -0.6889333333333334 -1.6631333333333331C14.709599999999998 0.4078 14.111333333333334 0.15999999999999998 13.4876 0.15999999999999998Zm-3.1359999999999997 9.243333333333332 -2.1324666666666667 4.798066666666666c-0.21819999999999998 -0.066 -0.4205333333333333 -0.176 -0.5946666666666667 -0.32313333333333333 -0.17406666666666665 -0.14726666666666666 -0.3161333333333333 -0.32853333333333334 -0.41746666666666665 -0.5327333333333333 -0.1014 -0.2042 -0.15986666666666666 -0.42699999999999994 -0.17186666666666664 -0.6546 -0.011999999999999999 -0.22766666666666668 0.02273333333333333 -0.45533333333333337 0.10206666666666667 -0.6690666666666667l0.4155333333333333 -1.1211333333333333c0.08853333333333332 -0.237 0.11846666666666666 -0.4918 0.08706666666666665 -0.7428 -0.031266666666666665 -0.25106666666666666 -0.12279999999999999 -0.49079999999999996 -0.26686666666666664 -0.6987333333333333 -0.144 -0.208 -0.3362666666666666 -0.37799999999999995 -0.5602 -0.49553333333333327 -0.224 -0.1176 -0.4731333333333333 -0.17919999999999997 -0.7260666666666666 -0.17973333333333333H2.5115999999999996c-0.11513333333333332 0.00019999999999999998 -0.22893333333333332 -0.024999999999999998 -0.33326666666666666 -0.07373333333333333 -0.10439999999999999 -0.048799999999999996 -0.19666666666666666 -0.11993333333333334 -0.2704 -0.20846666666666663 -0.07553333333333333 -0.08726666666666666 -0.13086666666666666 -0.19013333333333332 -0.16199999999999998 -0.30133333333333334 -0.0312 -0.11106666666666666 -0.037399999999999996 -0.22773333333333334 -0.018333333333333333 -0.3415333333333333l0.9957333333333334 -5.4879999999999995c0.0334 -0.18266666666666667 0.13046666666666668 -0.3475333333333333 0.2740666666666667 -0.4652666666666666 0.1436 -0.11766666666666666 0.32426666666666665 -0.18066666666666667 0.5099333333333333 -0.1776h6.844266666666667v7.675333333333333Zm3.92 -1.4033333333333333c0 0.20786666666666667 -0.08266666666666667 0.4073333333333333 -0.22966666666666663 0.5543333333333333s-0.34639999999999993 0.22966666666666663 -0.5543333333333333 0.22966666666666663h-1.5679999999999998V1.728h1.5679999999999998c0.20793333333333333 0 0.4073333333333333 0.08259999999999999 0.5543333333333333 0.22959999999999997 0.147 0.14706666666666665 0.22966666666666663 0.3464666666666667 0.22966666666666663 0.5544V8Z";
const Thumps_UP =
  "M15.291866666666666 6.4947333333333335c-0.22026666666666667 -0.2644666666666666 -0.49593333333333334 -0.4773333333333333 -0.8075333333333333 -0.6236666666666666 -0.31153333333333333 -0.14633333333333332 -0.6514666666666666 -0.2224 -0.9956666666666667 -0.223h-3.5749999999999997l0.43899999999999995 -1.1211333333333333c0.18259999999999998 -0.4908666666666666 0.24346666666666666 -1.0187333333333333 0.17726666666666668 -1.5382666666666664 -0.06626666666666667 -0.5195333333333333 -0.2574666666666666 -1.0152666666666665 -0.5573333333333332 -1.4446666666666665 -0.2998666666666666 -0.4294 -0.6994666666666666 -0.7796666666666666 -1.1644666666666665 -1.0206666666666666 -0.4649333333333333 -0.24106666666666665 -0.9815333333333333 -0.3657333333333333 -1.5051999999999999 -0.3632666666666667 -0.15086666666666665 0.0002666666666666667 -0.29833333333333334 0.04413333333333333 -0.4248666666666666 0.12613333333333332 -0.12653333333333333 0.08206666666666666 -0.22673333333333334 0.19886666666666666 -0.28859999999999997 0.33640000000000003L4.355066666666667 5.648066666666666H2.5126666666666666c-0.6237999999999999 0 -1.222 0.24779999999999996 -1.6630666666666667 0.6888666666666667C0.40846666666666664 6.778 0.16066666666666665 7.376266666666666 0.16066666666666665 8v5.4879999999999995c0 0.6237999999999999 0.24779999999999996 1.2221333333333333 0.6889333333333334 1.6632S1.8888666666666665 15.84 2.5126666666666666 15.84h9.980333333333332c0.5502 -0.00013333333333333334 1.0829333333333333 -0.19326666666666664 1.5055333333333334 -0.5456 0.4225333333333333 -0.35239999999999994 0.7082666666666666 -0.8417999999999999 0.8072666666666667 -1.3830666666666667l0.9956666666666667 -5.4879999999999995c0.06166666666666666 -0.33913333333333334 0.04786666666666667 -0.6877333333333333 -0.0402 -1.021s-0.24826666666666666 -0.6430666666666667 -0.46939999999999993 -0.9076ZM4.080666666666667 14.272H2.5126666666666666c-0.20793333333333333 0 -0.4073333333333333 -0.08253333333333332 -0.5543333333333333 -0.2295333333333333 -0.14706666666666665 -0.14713333333333334 -0.22966666666666663 -0.3464666666666667 -0.22966666666666663 -0.5544666666666667V8c0 -0.20793333333333333 0.08259999999999999 -0.40726666666666667 0.22966666666666663 -0.5544 0.147 -0.14693333333333333 0.34639999999999993 -0.22959999999999997 0.5543333333333333 -0.22959999999999997h1.5679999999999998v7.055999999999999Zm10.192 -6.130866666666667 -0.9956666666666667 5.4879999999999995c-0.0334 0.18266666666666667 -0.13053333333333333 0.3475333333333333 -0.2740666666666667 0.46519999999999995 -0.1436 0.11779999999999999 -0.32426666666666665 0.18073333333333333 -0.5099333333333333 0.17766666666666667H5.648666666666667V6.596666666666666l2.1324666666666667 -4.798066666666666c0.2195333333333333 0.064 0.4234 0.17279999999999998 0.5988 0.31953333333333334 0.17526666666666668 0.14673333333333333 0.31826666666666664 0.32826666666666665 0.4199333333333333 0.5330666666666666 0.10173333333333334 0.20479999999999998 0.1598 0.42846666666666666 0.17073333333333332 0.6567999999999999 0.010799999999999999 0.2284 -0.025733333333333334 0.45659999999999995 -0.10753333333333333 0.6701333333333334l-0.4155333333333333 1.1211333333333333c-0.08846666666666667 0.23693333333333333 -0.1184 0.4918 -0.08706666666666665 0.7428666666666667 0.031266666666666665 0.251 0.12286666666666665 0.4907333333333333 0.26686666666666664 0.6986666666666667 0.144 0.20793333333333333 0.3362666666666666 0.37799999999999995 0.5602666666666667 0.49559999999999993 0.224 0.1176 0.47306666666666664 0.17919999999999997 0.7260666666666666 0.17959999999999998h3.5749999999999997c0.1152 -0.00013333333333333334 0.229 0.024999999999999998 0.3334 0.07386666666666666 0.10426666666666667 0.04873333333333333 0.1966 0.11993333333333334 0.27026666666666666 0.20839999999999997 0.07553333333333333 0.08733333333333333 0.13086666666666666 0.19019999999999998 0.16206666666666666 0.3012666666666667 0.031133333333333332 0.1112 0.037399999999999996 0.2278 0.018266666666666667 0.34159999999999996Z";

/** DEFAULT SETING FOR gtag */
window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}

// Výchozí stav: vše zamítnuto.
// V této variantě se GA bez souhlasu vůbec nenačítá.
gtag("consent", "default", {
  analytics_storage: "denied",
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
});

/**
 * Cookies (class) - add cookies banner and button
 */
export default class Cokies {
  /**
   * @param {string} mainText (string) Default - Chcete udělat radost našim GIS specialistům a povolit cookies jen pro měření návštěvnosti a používání této aplikace?
   * @param {string} acceptBtnText (string) Default - Nemám s tím problém
   * @param {string} acceptBtnText (string) Default - Nemám s tím problém
   * @param {string} rejectBtnText (string) Default - Bohužel ne
   * @param {Array} svgRejectColor (array) Default - ["#212529","#343a40","#495057","#6c757d","#adb5bd","#ced4da"]
   * @param {Array} svgAcceptColor (array) Default - ["#212529","#343a40","#495057","#6c757d","#adb5bd","#ced4da"]
   * @param {string} svgRejectIcon (string) SvgPath Default - Thumbs Down - 'M13.4876 0...'
   * @param {string} svgAcceptIcon (string) SvgPath Default - Thumbs Up 'M13.4876 0...'
   *  @returns {object} Banner and Button HTML elements
   */
  constructor({
    mainText = DEFAULT_MAIN_TEXT,
    title = DEFAULT_TITLE,
    acceptBtnText = DEFAULT_ACCEPT_BT_TEXT,
    rejectBtnText = DEFAULT_REJECT_BT_TEXT,
    svgRejectColor = DEFAULT_COLORS,
    svgAcceptColor = DEFAULT_COLORS,
    svgRejectIcon = Thumps_DOWN,
    svgAcceptIcon = Thumps_UP,
  }) {
    this.mainText = mainText;

    this.acceptBtnText = acceptBtnText;
    this.rejectBtnText = rejectBtnText;
    this.svgRejectColor = svgRejectColor;
    this.svgAcceptColor = svgAcceptColor;
    this.svgRejectIcon = svgRejectIcon;
    this.svgAcceptIcon = svgAcceptIcon;
    this.title = title;

    this.elements = this.mainRun();
  }

  cokiesBaner() {
    // Baner
    const banner = document.createElement("div");
    banner.id = "cookie-banner";

    // Cokie box
    const cokieBox = document.createElement("div");
    cokieBox.classList.add("cookie-box");

    // Cokie header
    const cookieHeader = document.createElement("h3");
    cookieHeader.classList.add("cookies_header");
    cookieHeader.innerText = this.title + " ";

    // Cokie svg
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.id = "cookies_svg";
    svg.setAttribute("viewBox", "0 0 20 20.03");
    svg.innerHTML = `<path d="${COKIES_SVG_PATH}" class="svg-cookie__baner"/>`;

    // Main cokie text
    const cookieMainText = document.createElement("p");
    cookieMainText.innerText = this.mainText;

    // Cokie action
    const cookieAction = document.createElement("div");
    cookieAction.classList.add("cookie-actions");

    // Reject button
    const rejectBtn = document.createElement("button");

    rejectBtn.id = "cookie-reject";
    rejectBtn.innerText = this.rejectBtnText;

    // Accept button
    const acceptBtn = document.createElement("button");
    acceptBtn.id = "cookie-accept";
    acceptBtn.classList.add("primary");
    acceptBtn.innerText = this.acceptBtnText;

    if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
      new FlyingSVG({
        colors: this.svgRejectColor,
        btn: rejectBtn,
        csvPath: this.svgRejectIcon,
      });

      new FlyingSVG({
        colors: this.svgAcceptColor,
        btn: acceptBtn,
        csvPath: this.svgAcceptIcon,
      });
    }

    cookieHeader.appendChild(svg);
    cookieAction.appendChild(rejectBtn);
    cookieAction.appendChild(acceptBtn);

    cokieBox.appendChild(cookieHeader);
    cokieBox.appendChild(cookieMainText);
    cokieBox.appendChild(cookieAction);
    banner.appendChild(cokieBox);
    document.body.appendChild(banner);

    return {
      cokieBanerHTML: banner,
      cookieHeader: cookieHeader,
      cookieMainText: cookieMainText,
      rejectBtn: rejectBtn,
      acceptBtn: acceptBtn,
      svg: svg,
    };
  }

  cookiesButton() {
    const button = document.createElement("div");
    button.id = "cookie-settings-btn";
    button.classList.add("cookie-settings-btn");

    // Cokie svg
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");

    svg.setAttribute("viewBox", "0 0 20 20.03");
    svg.innerHTML = `<path d="${COKIES_SVG_PATH}" class="svg-cookie__button"/>`;

    button.appendChild(svg);
    document.body.appendChild(button);
    return {
      svg: svg,
      button: button,
    };
  }
  mainRun() {
    const baner = this.cokiesBaner();
    const button = this.cookiesButton();
    var STORAGE_KEY = "cookie_consent_v1";

    var banner = baner.cokieBanerHTML;
    var acceptBtn = baner.acceptBtn;
    var rejectBtn = baner.rejectBtn;
    var settingsBtn = button.button;

    var gaLoaded = false;

    function getStoredConsent() {
      return localStorage.getItem(STORAGE_KEY);
    }

    function setStoredConsent(value) {
      localStorage.setItem(STORAGE_KEY, value);
    }

    function clearStoredConsent() {
      localStorage.removeItem(STORAGE_KEY);
    }

    function showBanner() {
      banner.style.display = "block";
    }

    function hideBanner() {
      banner.style.display = "none";
    }

    function loadGoogleAnalytics(callback) {
      if (gaLoaded) {
        if (typeof callback === "function") callback();
        return;
      }

      var script = document.createElement("script");
      script.async = true;
      script.src =
        "https://www.googletagmanager.com/gtag/js?id=" +
        encodeURIComponent(GA_ID);

      script.onload = function () {
        gaLoaded = true;

        gtag("js", new Date());

        // Vypneme automatický pageview a pošleme ho ručně až po consent update.
        gtag("config", GA_ID, {
          send_page_view: false,
        });

        if (typeof callback === "function") callback();
      };

      document.head.appendChild(script);
    }

    function enableAnalytics() {
      setStoredConsent("accepted");

      loadGoogleAnalytics(function () {
        gtag("consent", "update", {
          analytics_storage: "granted",
          ad_storage: "denied",
          ad_user_data: "denied",
          ad_personalization: "denied",
        });

        gtag("event", "page_view", {
          page_title: document.title,
          page_location: window.location.href,
          page_path: window.location.pathname,
        });
      });

      hideBanner();
    }

    function disableAnalytics() {
      setStoredConsent("rejected");

      gtag("consent", "update", {
        analytics_storage: "denied",
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
      });

      hideBanner();
    }

    function openSettings() {
      clearStoredConsent();
      if (banner.style.display === "block") {
        hideBanner();
      } else {
        showBanner();
      }
    }

    function isHidden(el) {
      return el.offsetParent === null;
    }

    acceptBtn.addEventListener("click", enableAnalytics);
    rejectBtn.addEventListener("click", disableAnalytics);
    settingsBtn.addEventListener("click", openSettings);

    var storedConsent = getStoredConsent();

    if (storedConsent === "accepted") {
      enableAnalytics();
    } else if (storedConsent === "rejected") {
      disableAnalytics();
    } else {
      showBanner();
    }
    return {
      baner: baner,
      button: button,
    };
  }
}

class FlyingSVG {
  constructor({
    colors = DEFAULT_COLORS,
    csvPath = DEFAULT_HEART_PATH,
    btn,
  } = {}) {
    this.colors = colors;
    this.csvPath = csvPath;
    this._curX = 0;
    this._curY = 0;
    this._timer = null;
    this._onMove = this._onMove.bind(this);
    if (btn) this._attach(btn);
  }

  _attach(btn) {
    btn.addEventListener("mouseenter", (e) =>
      this.start(btn, e.clientX, e.clientY),
    );
    btn.addEventListener("mouseleave", () => this.stop(btn));
  }

  _onMove(e) {
    this._curX = e.clientX;
    this._curY = e.clientY;
  }

  _spawnOne() {
    const size = 10 + Math.random() * 18;
    const color = this.colors[Math.floor(Math.random() * this.colors.length)];
    const driftX = (Math.random() - 0.5) * 90;
    const riseY = 55 + Math.random() * 65;
    const spin = (Math.random() - 0.5) * 70;
    const dur = 850 + Math.random() * 500;

    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.classList.add("fly-svg");
    svg.style.cssText = `
      left:   ${this._curX - size / 2}px;
      top:    ${this._curY - size / 2}px;
      width:  ${size}px;
      height: ${size}px;
      fill:   ${color};
    `;
    svg.innerHTML = `<path d="${this.csvPath}"/>`;
    document.body.appendChild(svg);

    anime({
      targets: svg,
      translateX: driftX,
      translateY: -riseY,
      rotate: spin,
      opacity: [
        { value: 1, duration: 100 },
        { value: 0, duration: dur - 100, easing: "easeInQuad" },
      ],
      scale: [0.2, 1.1, 0.7],
      duration: dur,
      easing: "easeOutCubic",
      complete: () => svg.remove(),
    });
  }

  start(btn, initialX, initialY) {
    this._curX = initialX;
    this._curY = initialY;
    btn.addEventListener("mousemove", this._onMove);
    for (let i = 0; i < 5; i++) setTimeout(() => this._spawnOne(), i * 60);
    this._timer = setInterval(() => this._spawnOne(), 140);
  }

  stop(btn) {
    clearInterval(this._timer);
    btn.removeEventListener("mousemove", this._onMove);
  }

  burst(x, y, count = 8) {
    this._curX = x;
    this._curY = y;
    for (let i = 0; i < count; i++) setTimeout(() => this._spawnOne(), i * 40);
  }
}
